import React, { useState } from "react";
import CreatePublish from "../create_published/CreatePublish";
import PreUpload from "./pre_question_type/PreUpload";
import PreMcq from "./pre_question_type/PreMcq";
import DraftPublish from "../../On_going/Draft/Draft_Q_list/DraftPublish";
// css comes in  preview QuestionListHomework.css

const QuestionListAssessment = ({
  change,
  questions,
  setQuestions,
  assessmentDetails,
  setAssessmentDetails,
  isForEditing,
  isScheduledEditing,
  total_marks,
  name,
  sourceLibrary
}) => {
  const [click, setClick] = useState(false);

  return (
    <>
      {!click && (
        <div className="preview_transprant_body">
          <div className=" p-2 preview_container shadow">
            <img
              src="/images/cross-circle3.svg"
              className="preview_Q_close_btn"
              alt=""
              onClick={(e) => change(false)}
            />
            <div className=" col-12 d-flex align-items-center justify-content-between">
              <span className="preview_container_header">
               {name}
              </span>
              <div className=" durationAndPubButton">
              <div >
              <div className=" preview_marks_time_management_Assessment">
                <div className=" col-4 qno_manage">
                  <span className="">Total Questions :</span>
                  <span> {questions?.length}</span>
                </div>
                <div className=" col-4 qno_manage">
                  <span className="">Total Marks :</span>
                  <span> {total_marks}</span>
                </div>
                <div className="  qno_manage">
                  <span className="">Total Duration :</span>
                  <span> {assessmentDetails?.total_duration} min </span>
                </div>
              </div>
            </div>
            <div>
              <button className="Edit_Btn" onClick={(e) => setClick(true)} >
                Publish
              </button>
            </div>
              </div>
            </div>
            
            <div className="preview_question_lists">
              {questions.length > 0 &&
                questions.map((question, index) =>
                  question.question_type === "false" ? (
                    <PreMcq
                      key={index}
                      nextQuestion={index}
                      question={question}
                    />
                  ) : (
                    <PreUpload
                      key={index}
                      nextQuestion={index}
                      question={question}
                    />
                  )
                )}
            </div>
          </div>
        </div>
      )}
      {click && !isForEditing && (
        <CreatePublish
          setClick={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          questions={questions}
          sourceLibrary={sourceLibrary}
        />
      )}

      {click && (isForEditing || isScheduledEditing) && (
        <DraftPublish
          setClick={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          questions={questions}
          isScheduledEditing={isScheduledEditing}
        />
      )}
    </>
  );
};
export default QuestionListAssessment;
